import { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getCustomerProfile } from "../../api";
import { SearchContext } from "../../context/SearchContext";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const [customerName, setCustomerName] = useState({
    first_name: "",
    last_name: "",
  });
  const dropdownRef = useRef(null);
  const iconRef = useRef(null);

  const handleDropdownToggle = () => setDropdownVisible((v) => !v);

  const handleLogout = () => {
    window.location.href = "https://www.tennisshop.ae/";
  };

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await getCustomerProfile();
        setCustomerName({
          first_name: response.data.first_name || "",
          last_name: response.data.last_name || "",
        });
      } catch (err) {
        console.error("Failed to fetch customer profile:", err);
      }
    };
    fetchCustomer();
  }, []);

  // Close on outside click or ESC
  useEffect(() => {
    const onClickOutside = (e) => {
      if (
        dropdownVisible &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        iconRef.current &&
        !iconRef.current.contains(e.target)
      ) {
        setDropdownVisible(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setDropdownVisible(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEsc);
    };
  }, [dropdownVisible]);

  const getInitials = () => {
    const { first_name, last_name } = customerName;
    return `${first_name?.[0] || "A"}${last_name?.[0] || "B"}`.toUpperCase();
  };

  const handleProfileNavigation = () => navigate("/customer/dashboard/profile");

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  return (
    <header className={styles.navbar}>
      <div className={styles.left}>
        <input
          type="text"
          placeholder="Search"
          className={styles.searchBar}
          value={searchTerm}
          onChange={handleSearchChange}
          aria-label="Search"
        />
      </div>

      <div className={styles.userSection}>
        <button
          ref={iconRef}
          className={styles.userIcon}
          onClick={handleDropdownToggle}
          aria-haspopup="menu"
          aria-expanded={dropdownVisible}
          aria-label="Open user menu"
        >
          {getInitials()}
        </button>

        {dropdownVisible && (
          <div ref={dropdownRef} className={styles.dropdownMenu} role="menu">
            <button
              className={styles.dropdownItem}
              onClick={handleProfileNavigation}
              role="menuitem"
            >
              Profile
            </button>
            <button
              className={styles.dropdownItem}
              onClick={handleLogout}
              role="menuitem"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
